module.exports = __webpack_public_path__ + "img/loading-blue.dc9878fb.svg";